import { getEl } from '../helpers/helpers.js'
import { isAnalyticsEnabled, setAnalytics } from '../helpers/preferences.js'
import {
	setCheckboxState,
	togglePlausibleScript,
} from '../helpers/analyticsConsent.js'

export function initAnalyticsConsent() {
	const checkbox = getEl('[data-track-check]')
	if (!checkbox) return false

	const isEnabled = isAnalyticsEnabled()
	setCheckboxState(checkbox, isEnabled)
	togglePlausibleScript(isEnabled)
	checkbox.addEventListener('change', () => {
		const isNowEnabled = checkbox.checked
		setAnalytics(isNowEnabled)
		togglePlausibleScript(isNowEnabled)
	})

	return true
}
